import { useCallback } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import { useQuery } from "react-query";
import {
  useNotify,
  SimpleForm,
  TextInput,
  useResourceContext,
  required,
  maxLength,
  useRefresh,
  useUpdate,
  Edit,
  BooleanInput,
  minLength,
  useDataProvider,
  AutocompleteInput,
} from "react-admin";
import SaveDeleteBtns from "../../saveDeleteBtns/SaveDeleteBtn";

const validateName = [required(), maxLength(20)];
const validateCode = [required(), minLength(3), maxLength(3)];
const validateBrand = [required(), minLength(36), maxLength(36)];
const validateActive = [required()];

export default function MotifEditDialog({ open, setOpen, recordId }) {
  const [update] = useUpdate();
  const notify = useNotify();
  const refresh = useRefresh();
  const resource = useResourceContext(); // cuman nama resource
  const dataProvider = useDataProvider();

  // GET BRAND LISTS
  const {
    data: brands,
    isLoading: isLoadingBrands,
    error: brandError,
  } = useQuery(["brands/select", "getListNoParams"], () =>
    dataProvider.getListNoParams("brands/select")
  );
  // GET BRAND LISTS

  const save = useCallback(
    async (values) => {
      const id = values.id ?? recordId;

      try {
        await update(
          resource,
          { id, data: values },
          {
            returnPromise: true,
            onSuccess: (data) => {
              notify("ra.notification.updated", {
                messageArgs: { smart_count: 1 },
              });
              setOpen(false);
              refresh();
            },
          }
        );
      } catch (error) {
        if (error.body && error.body.errors) {
          // The shape of the returned validation errors must match the shape of the form
          return error.body.errors;
        }
        return undefined;
      }
    },
    [notify, recordId, refresh, resource, setOpen, update]
  );

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} keepMounted={false}>
      <Edit
        title={" "}
        id={recordId}
        actions={false}
        sx={{ "& .RaEdit-main": { mt: 0 } }}
      >
        <SimpleForm
          warnWhenUnsavedChanges
          onSubmit={save}
          toolbar={<SaveDeleteBtns callback={handleClose} />}
          mode="onBlur"
          reValidateMode="onBlur"
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pt: 0,
            }}
          >
            <DialogTitle>Edit Motif</DialogTitle>
            <IconButton onClick={handleClose} sx={{ mr: "11px" }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <DialogContent>
            <TextInput source="id" sx={{ display: "none" }} />

            <TextInput
              variant="outlined"
              source="name"
              fullWidth
              isRequired
              validate={validateName}
            />

            <TextInput
              variant="outlined"
              source="code"
              fullWidth
              isRequired
              validate={validateCode}
            />
            <AutocompleteInput
              variant="outlined"
              source="brand_id"
              isRequired
              choices={isLoadingBrands ? [] : brands}
              fullWidth
              validate={validateBrand}
              resettable
            />
            <BooleanInput
              variant="outlined"
              source="active"
              fullWidth
              isRequired
              validate={validateActive}
            />
          </DialogContent>
        </SimpleForm>
      </Edit>
    </Dialog>
  );
}
